import { Spinner } from "@fluentui/react-components";
import styles from "./SettingsLoadingNotice.module.css";

/**
 * Full-pane neutral loading state shown while the studio settings load is in
 * flight, so the chat surface doesn't flash before the channel-access gate
 * (ChannelUnavailableNotice / AccountNotFoundNotice) can settle (AIVA-5817).
 */
export function SettingsLoadingNotice() {
  return (
    <output className={styles.container}>
      <Spinner label="Loading…" />
    </output>
  );
}
